import path from 'path-browserify';

import { getBaseUrl } from '@api/base-url';

const base = (): string => path.join(getBaseUrl({ version: 1 }), 'lookup/');

const urls = Object.freeze({
  emailVerificationCodeEmail: (): string => path.join(
    base(),
    'email/email-verification-code/',
  ),
  passwordResetCodeEmail: (): string => path.join(
    base(),
    'email/password-reset-code/',
  ),
  tenantInvitationCodeEmail: (): string => path.join(
    base(),
    'email/tenant-invitation-code/',
  ),
  tenantInvitationCodeTenant: (): string => path.join(
    base(),
    'tenant/tenant-invitation-code/',
  ),
});

export default urls;
